export const AI_REPORT_CTA_SECTION_IMAGES_TRANSLATIONS = {
    CHART_HEADER_TEXT: "ai_report_cta_section_images.chart_header_text",
    CHART_ITEM_TEXT: "ai_report_cta_section_images.chart_item_text",
    DATA_SECTION_HEADER_TEXT: "ai_report_cta_section_images.data_section_header_text",
    DATA_SECTION_SUBTEXT_TEXT: "ai_report_cta_section_images.data_section_subtext_text",
} as const;
